import { schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function deleteLabMember(labMemberId: number) {
  return fetch(
    `/lab-member/${labMemberId}`,
    { method: 'DELETE' },
    schemas.DeleteLabMemberResponse
  );
}

export const useDeleteLabMemberMutation = () => {
  return useMutation({
    mutationKey: ['deleteLabMember'],
    retry: false,
    mutationFn: async (labMemberId: number) => {
      const result = deleteLabMember(labMemberId);
      return result;
    }
  });
};
